var map = {
	"./gg-cn-btn.png": "3CKF",
	"./gg-de-btn.png": "5pfs",
	"./gg-en-btn.png": "CVHL",
	"./gg-es-btn.png": "pJRG",
	"./gg-fr-btn.png": "O32R",
	"./gg-pt-btn.png": "CXJu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KdA3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/gg ^\.\/gg\-.*\-btn\.png$
// module id = KdA3
// module chunks = 1